// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3_Ci9","actionsCol":"EnrolledClinics_actionsCol__3F2M3"};